import cn from 'classnames';
import { ButtonUI, Tooltip, TooltipInteractionEnum } from 'sonata-react-components';

import type { ToolButtonConfig } from '../ActionToolsPanel.types';

import './toolButton.scss';

export function ToolButton({
  icon,
  id,
  isActive = false,
  disabled = false,
  onClick,
  text,
  tooltip,
  ...buttonProps
}: ToolButtonConfig) {
  return (
    <div
      className={cn('toolButton', {
        'toolButton--active': isActive,
        'toolButton--disabled': disabled
      })}
      data-testid={`tool-button-${id}`}
    >
      <Tooltip
        config={{
          arrow: true,
          component: <div className="actionToolsPanel__tooltipWrapper">{tooltip}</div>,
          forcePlacement: true,
          interactions: [TooltipInteractionEnum.hover],
          placement: 'top',
          portal: true,
          strategy: 'absolute'
        }}
      >
        <ButtonUI
          className="toolButton__button"
          disabled={disabled}
          icon={icon}
          id={id}
          onClick={onClick}
          selected={isActive}
          shape="squareRounded"
          size="small"
          type="secondary"
          {...buttonProps}
        />
      </Tooltip>
      <span className="toolButton__label">{text}</span>
    </div>
  );
}
